import { calcBestThirdFromGroups, calcGroupStandingsFromFixtures } from "./groupStandings";
import { decidedFixtureWinnerCode } from "./matchScores";

function groupFullyFinished(fixtures, group) {
  let seen = false;
  for (const m of fixtures || []) {
    if (m.stage !== "GROUP" || m.group !== group) continue;
    if (!m.home_code || !m.away_code) continue;
    seen = true;
    if (m.status !== "FINISHED" || m.home_score == null || m.away_score == null) return false;
  }
  return seen;
}

/**
 * Team codes eliminated from the live tournament (group exits + KO losses).
 * Conservative: 3rd-placed teams only marked out once all groups are finished.
 */
export function computeEliminatedTeamCodes(fixtures, groups, fairPlay = null) {
  const eliminated = new Set();
  if (!fixtures?.length || !groups || !Object.keys(groups).length) return eliminated;

  const groupStandings = calcGroupStandingsFromFixtures(fixtures, groups, null, fairPlay);
  const groupKeys = Object.keys(groups);
  const allGroupsFinished = groupKeys.length > 0 && groupKeys.every((g) => groupFullyFinished(fixtures, g));
  const bestThird = allGroupsFinished ? calcBestThirdFromGroups(groupStandings, fairPlay) : [];
  const qualifiedThirdCodes = new Set(bestThird.filter((r) => r.qualified).map((r) => r.code));

  for (const g of groupKeys) {
    if (!groupFullyFinished(fixtures, g)) continue;
    const rows = groupStandings[g] || [];
    if (rows.length >= 4) eliminated.add(rows[3].code);
    if (rows.length >= 3 && allGroupsFinished && !qualifiedThirdCodes.has(rows[2].code)) {
      eliminated.add(rows[2].code);
    }
  }

  for (const m of fixtures) {
    if (m.stage === "GROUP" || m.status !== "FINISHED") continue;
    const winner = decidedFixtureWinnerCode(m);
    const home = m.home_code;
    const away = m.away_code;
    if (!winner || !home || !away) continue;
    eliminated.add(winner === home ? away : home);
  }

  return eliminated;
}

/** Teams confirmed for the final (both slots when known). Never struck on finalist rows. */
export function computeFinalParticipantCodes(fixtures) {
  const codes = new Set();
  for (const m of fixtures || []) {
    if (m.stage !== "FINAL") continue;
    if (m.home_code) codes.add(m.home_code);
    if (m.away_code) codes.add(m.away_code);
  }
  return codes;
}
